module.exports = ".brand {\n  -ms-flex-line-pack: rigth;\n      align-content: rigth; }\n\n.align-buttons {\n  text-align: right; }\n\ntd {\n  border: 1px solid; }\n\n.pdf-container {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-model-brand-contents/master-model-brand-contents.component.scss
// module id = ./src/app/master/master-model-brand-contents/master-model-brand-contents.component.scss
// module chunks = main